import React from "react";
import { createRoot } from "react-dom/client";
import { DOM_ROOT_ID } from "./constants";

import "./customtheme.scss";
import App from "./App";

// Expose utilities for console debugging
import OfflineStore from "./util/OfflineStore";
import OfflineSync from "./util/OfflineSync";
window.OfflineStore = OfflineStore;
window.OfflineSync = OfflineSync;

// After a deploy, cached HTML references old webpack chunk hashes that no
// longer exist on the CDN. Loading those chunks throws ChunkLoadError from
// several async paths (lazy imports, CSS link tags, service worker). On the
// first such error, hard-reload once to pick up the current HTML + chunks.
// sessionStorage flag prevents reload loops if the failure is real (404 on
// a current chunk).
const CHUNK_RELOAD_FLAG = "chunk-reload-attempted";

const is_chunk_load_error = (source) => {
	if (!source) {
		return false;
	}
	const name = source.name || source.error?.name;
	const message = source.message || source.error?.message || "";
	return name === "ChunkLoadError"
		|| /Loading (CSS )?chunk [\w-]+ failed/i.test(message);
};

const handle_chunk_load_error = () => {
	if (sessionStorage.getItem(CHUNK_RELOAD_FLAG)) {
		return;
	}
	sessionStorage.setItem(CHUNK_RELOAD_FLAG, String(Date.now()));
	window.location.reload();
};

window.addEventListener("error", (event) => {
	if (is_chunk_load_error(event.error) || is_chunk_load_error(event)) {
		handle_chunk_load_error();
	}
});
window.addEventListener("unhandledrejection", (event) => {
	if (is_chunk_load_error(event.reason)) {
		handle_chunk_load_error();
	}
});

const container = document.getElementById(DOM_ROOT_ID || "root");

const url = new URL(window.location.href);
["nocache", "manscan"].forEach(param => {
	if (url.searchParams.has(param)) {
		url.searchParams.get(param).toLowerCase() === "false"
			? localStorage.removeItem(param)
			: localStorage.setItem(param, "true");
		url.searchParams.delete(param);
	}
});
if (url.toString() !== window.location.href) {
	window.history.pushState(null, null, url);
}

const root = createRoot(container);
root.render(
	// <React.StrictMode>
		<App tab="home" />
	// </React.StrictMode>
);

// Clear the reload flag once the session has stayed alive for a while, so a
// later deploy in the same tab can trigger a fresh reload.
setTimeout(() => sessionStorage.removeItem(CHUNK_RELOAD_FLAG), 10000);

// In dev, unregister any leftover service workers to prevent reload loops
if ("serviceWorker" in navigator && process.env.NODE_ENV !== "production") {
	navigator.serviceWorker.getRegistrations().then(regs => regs.forEach(r => r.unregister()));
}

// Register offline service worker for background sync (production only — dev server conflicts with SW lifecycle)
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
	window.addEventListener("load", () => {
		navigator.serviceWorker.register("/offline-sw.js")
			.then((registration) => {
				console.warn("[ServiceWorker] Registered:", registration.scope);

				// Register for background sync if supported
				if ("sync" in registration) {
					registration.sync.register("offline-sync").catch(() => {
						// Background sync not supported or permission denied
					});
				}

				// SW message listener is managed by OfflineManager.Init()
			})
			.catch((error) => {
				console.warn("[ServiceWorker] Registration failed:", error);
			});
	});
}

